import { IFilterConfig } from "../interfaces";

import { tagFilterConfigMultiple } from "./default-config-multiple";

export const tagFilterConfigSingle: IFilterConfig = {
  ...tagFilterConfigMultiple,
  multiple: false,
};
